"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FORM_ID = 'accept-sso-redirect-form';
const form = document.getElementById(FORM_ID);
if (form) {
    form.submit();
}
